// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__37g6v","col":"CardReaderDesc_col__3HdE_","label":"CardReaderDesc_label__3k4ie"};